module.exports = __webpack_public_path__ + "img/todaySale.b4f945d6.png";